import { Lock, Waypoints } from 'lucide-react';
import styles from './Terminal.module.css';

interface TerminalHeaderProps {
  title: string;
}

export const TerminalHeader = ({ title }: TerminalHeaderProps) => (
  <div className={styles.header}>
    <Waypoints className="w-5 h-5 -mt-6" />
    <h1 className={styles.title}>{title}</h1>
    <div className={styles.status}>
      <Lock className="w-6 h-6" />
      <span className="text-base">SECURE_CONNECTION</span>
    </div>
  </div>
);
